import { useEffect, useRef } from 'react'

export const useFocusTrap = (hasFocus: boolean, onLoseFocus: Function, delay = 400) => {
  type Timer = ReturnType<typeof setTimeout>

  const timerRef = useRef<Timer | null>(null)

  useEffect(() => {
    if (!hasFocus) {
      timerRef.current = setTimeout(() => onLoseFocus(), delay)
    }

    if (hasFocus && timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }

    return () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current)
      }
    }
  }, [hasFocus])
}
